<template>
    <b-card-body class="pt-0">
        <div class="row">
            <div class="col-md-6">
                <EditorDate :item="field('65fb79e6cd239776f7faa407')" :entity="entity" scope="module" :validate="false" internal="Action dato" />
            </div>
            <div class="col-md-6">
                <EditorSelect :item="field('65fb79a9cd239776f7faa3fe')" :entity="entity" scope="module" :validate="false" internal="Action" />
            </div>

            
            <div class="col-md-6">
                <EditorSelect :item="field('5e2c6b09329b745cdca400b6')" :entity="entity" scope="module" :validate="false" internal="Kølevare" />
            </div>
            <div class="col-md-6">
                <EditorDate :item="field('5e2c6b1f329b745cdca400bb')" :entity="entity" scope="module" :validate="false" internal="Udløbsdato" />
            </div>
            
            <div class="col-md-6">
                <EditorSelect :item="field('67c116e6ef2f47ea758f704d')" :entity="entity" scope="module" :validate="false" internal="5°C køleprodukt" />
            </div>
            <div class="col-md-6">
                <EditorDate :item="field('67c13e639b2bab44b8272bef')" :entity="entity" scope="module" :validate="false" internal="5°C køleprodukt dato" />
            </div>

            <div class="col-md-6">
                <EditorSelect :item="field('67c116f1ef2f47ea758f704e')" :entity="entity" scope="module" :validate="false" internal="Frostprodukt" />
            </div>
            <div class="col-md-6">
                <EditorDate :item="field('67c13e879b2bab44b8272bfa')" :entity="entity" scope="module" :validate="false" internal="Frostprodukt dato" />
            </div>
            
            <div class="col-md-6">
                <EditorSelect :item="field('689389049f68823fc1077498')" :entity="entity" scope="module" :validate="false" internal="Tørvare" />
            </div>
            <div class="col-md-6">
                <EditorDate :item="field('689389249f68823fc10774a5')" :entity="entity" scope="module" :validate="false" internal="Tørvare dato" />
            </div>

            <div class="col-md-6">
                <EditorSelect :item="field('68938bd99f68823fc107771c')" :entity="entity" scope="module" :validate="false" internal="Intern" />
            </div>
            <div class="col-md-6">
                <EditorDate :item="field('68938bed9f68823fc1077724')" :entity="entity" scope="module" :validate="false" internal="Intern dato" />
            </div>




            <div class="col-md-6">
                <EditorNumber :item="field('5e78e08f2f21322de8a06365')" :entity="entity" scope="module" :validate="false" internal="Min. vægt" />
            </div>
            <div class="col-md-6">
                <EditorNumber :item="field('5e78e0a02f21322de8a06368')" :entity="entity" scope="module" :validate="false" internal="Max. vægt" />
            </div>
        </div>
    </b-card-body>
</template>

<script>
    import mixin from "../../mixins/area";
    import Editors from "../../mixins/editors";

    export default {
        data: () => ({}),
        components: { ...Editors },
        computed: {},
        methods: {},
        created() {
        },
        mounted() {


        },
        mixins: [mixin]
    };
</script>